import React from 'react';
import {Row, Col, Card} from 'react-materialize';


import {FormattedMessage, FormattedHTMLMessage} from 'react-intl';

const Sobre = () => (

    <Card>

        <Row>
            <div align="center">
                <h5><p><b><FormattedMessage id={"mask_disposal_title"} defaultMessage={"Atenção ao descarte de máscaras"}/></b></p></h5>
            </div>
            <div align="justify" style={{padding:"50px"}}>
                <ul>
                    <li>• <FormattedMessage id={"mask_disposal_text_1"} defaultMessage={"As máscaras que não vêm dos serviços de saúde devem ser descartadas no lixo comum (não reciclável)."}/></li>
                    <li>• <FormattedMessage id={"mask_disposal_text_2"} defaultMessage={"Remova a máscara e coloque em um saco separado."}/></li>
                    <li>• <FormattedMessage id={"mask_disposal_text_3"} defaultMessage={"Descartar imediatamente em uma lixeira fechada."}/></li>
                </ul>
            </div>
            <div align="center">
                <a href={"/masks"} style={{background:'white', color: 'black'}}>
                    <button style={{backgroundColor:"#7F7FFF", border:"white", borderRadius:"15px"}}>
                        <h5><FormattedMessage id={"back"} defaultMessage={"VOLTAR"}/></h5>
                    </button>
                </a>
            </div>
        </Row>

        

    </Card>

);

export default Sobre;